import instance from "../utils/api_instance.util";

export const fetchAllCarouselData = async () => {
    try {
        const { data } = await instance.get('/api/v1/carousel/getAllCarouselData');
        return data;
    } catch (err) {
        throw err;
    }
}

export const createCarousalData = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/carousel/addCarousal', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateCarousalAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/carousel/update_status', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const editCarousalAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/carousel/update_carousel', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

/**
 * Scroll Info APIs
 */
export const getScrollInfoAPI = async () => {
    try {
        const { data } = await instance.get('/api/v1/carousel/getScrollInfo');
        return data;
    } catch (err) {
        throw err;
    }
};

export const updateScrollInfoAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/carousel/updateScrollInfo', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};
